import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: null };

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, message: error instanceof Error ? error.message : String(error) };
  }

  componentDidCatch(error: unknown, info: { componentStack: string }) {
    console.error('[ErrorBoundary] caught render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          position: 'fixed', bottom: 16, right: 16, zIndex: 999,
          background: '#2a1010', border: '1px solid rgba(255,80,80,0.4)',
          color: '#ffb4b4', padding: '10px 14px', borderRadius: 10,
          fontSize: 12, maxWidth: 360, boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
        }}>
          Something went wrong rendering this panel: {this.state.message}
        </div>
      );
    }
    return this.props.children;
  }
}
